<template>
  <div id="contract">
    <div class="page">
      <header class="page__header">
        <router-link to="/">
          <img src="../assets/images/logo.png" alt="Heldengame" @click="this.reset" />
        </router-link>
        <h1>Heldencontract</h1>
      </header>
      <ul>
        <li :key="manifest.id" v-for="manifest in manifests">
          {{ manifest.rule }}
        </li>
      </ul>
      <img class="page__footer" src="../assets/images/heldenContractSwoosh.png" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Contract',
  computed: mapState([
    'manifests'
  ]),
  methods: mapActions([
    'reset'
  ]),
  mounted () {
    setTimeout(window.print, 1000)
  }
}
</script>

<style scoped lang="scss">
#contract {
  background-color: $color-black;
}

.page {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  max-width: 76.8rem;
  min-height: 100vh;
  margin: 0 auto;
  font-size: 3rem;
  background-color: $color-white;

  ul {
    flex: 1;
    margin-left: 5%;
    list-style: none;
  }

  li {
    margin-bottom: 1.5rem;
  }
}

.page__header {
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  margin-bottom: 3rem;

  a {
    display: block;
    width: 40%;
  }

  h1 {
    margin-bottom: 4%;
  }
}

.page__footer {
  margin-top: -12%;
}
</style>
